import { render } from "./PrivacyPolicy.vue?vue&type=template&id=2782f080&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "@/assets/css/about.css?vue&type=style&index=0&id=2782f080&scoped=true&lang=css"
import "./PrivacyPolicy.vue?vue&type=style&index=1&id=2782f080&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2782f080"]])

export default __exports__